/**
 * @typedef \{\{
 *    id: string;
 *    title: string;
 *    appliesOnOneTimePurchase: boolean;
 *    value: {
 *      percentage: number;
 *    };
 *    appliesTo: "collections";
 *    collections: {
 *      title: string;
 *      id: string;
 *    }[];
 *    products: [];
 * }} Discount
 */
class UncsDiscountsService {
  static instance = null;
  static isInitializing = false;
  static initializationPromise = null;

  constructor() {
    if (UncsDiscountsService.instance) {
      return UncsDiscountsService.instance;
    }

    this.apiUrl = 'https://mustek.uncs.eu';
    this.discounts = null;
  }

  /**
   * @returns {UncsDiscountsService}
   */
  static getInstance() {
    if (!UncsDiscountsService.instance) {
      UncsDiscountsService.instance = new UncsDiscountsService();
    }
    return UncsDiscountsService.instance;
  }

  /**
   * @returns {Promise<Discount[]>}
   */
  async getDiscounts() {
    if (this.discounts !== null) {
      return this.discounts;
    }

    if (UncsDiscountsService.isInitializing) {
      return UncsDiscountsService.initializationPromise;
    }

    UncsDiscountsService.isInitializing = true;
    UncsDiscountsService.initializationPromise = this._fetchDiscounts();

    try {
      this.discounts = await UncsDiscountsService.initializationPromise;
      return this.discounts;
    } finally {
      UncsDiscountsService.isInitializing = false;
      UncsDiscountsService.initializationPromise = null;
    }
  }

  /**
   * @returns {Promise<Discount[]>}
   */
  async _fetchDiscounts() {
    try {
      const response = await fetch(`${this.apiUrl}/api/discounts/automatic`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching discounts:', error);
      return [];
    }
  }
} 